/**
 *
 * Asynchronously loads the component for OnboardingWorkProfile
 *
 */

import { lazyLoad } from 'utils/loadable';

export const OnboardingWorkProfile = lazyLoad(
  () => import('./index'),
  module => module.OnboardingWorkProfile,
);
